<template>
	<div :id="modalName">
		<b-modal :id="modalName" title="Last Invoice" scrollable hide-footer size="lg">
            <template v-slot:modal-title>
                <span>Last Sales Order: {{ name }} (#{{ row.sales_order_number }})</span>
            </template>

            <div v-if="isBusy" class="text-center">
                <b-spinner label="Loading..."></b-spinner>
            </div>

            <b-table-simple v-else hover small responsive bordered striped hover sticky-header="480px" :busy="isBusy">
                <b-thead>
                    <b-tr>
                        <b-th></b-th>
                        <b-th>SKU</b-th>
                        <b-th>Name</b-th>
                        <b-th class="text-center">QTY</b-th>
                        <b-th class="text-center">Price</b-th>
                        <b-th class="text-center">Total</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr v-for="(line, index) in invoiceLines" :key="index">
                        <b-td class="text-center"><b-img-lazy v-if="line.imgUrl && line.sku != 'CUSTOM'" class="thumbnail" :src="line.imgUrl"></b-img-lazy></b-td>
                        <b-td>{{ line.sku }}</b-td>
                        <b-td>{{ line.name }}</b-td>
                        <b-td class="text-center">{{ line.qty }}</b-td>
                        <b-td class="text-center">${{ line.price }}</b-td>
                        <b-td class="text-center">${{ line.qty * line.price }}</b-td>
                    </b-tr>
                    <b-tr v-if="invoiceLines.length">
                        <b-td colspan="3"></b-td>
                        <b-td class="text-center"><strong>{{ invoiceLinesTotals.qty }}</strong></b-td>
                        <b-td class="text-center"><strong>${{ invoiceLinesTotals.price.toFixed(2) }}</strong></b-td>
                        <b-td class="text-center"><strong>${{ invoiceLinesTotals.total.toFixed(2) }}</strong></b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </b-modal>
	</div>
</template>

<script>
	export default {
		props: [
            'row',
            'name'
		],

		components: {

		},

		data() {
			return {
                modalName: 'modal-lists-customers-show-last-invoice',

                invoiceLines: [],
                invoiceLinesTotals: [],

                isBusy: true
			}
		},

		methods: {
            getInvoiceLines() {
                let url = 'api/lists/customers/getinvoicelines/' + this.row.id
                axios.get(url, {})
                .then((res) => {
                    this.invoiceLines = res.data.invoiceLines
                    this.invoiceLinesTotals = res.data.invoiceLinesTotals
                    this.isBusy = false
                }, () => {
                    this.has_error = true
                })
            }
		},

		computed: {

		},

		mounted() {
            this.getInvoiceLines()
		}
	}
</script>
<style lang="scss">
    #modal-lists-customers-show-last-invoice {
        .modal-content {
            max-height: 600px;
        }

        table {
            font-size: 9pt;

            .thumbnail {
                width: 40px;
                height: 40px;
            }
        }
    }
</style>
